module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step3_1-b55e6fd2650db100a95259976960c2e9.png";